import { FormEvent } from 'react';

function maskInput(mask: (string | RegExp)[]) {
  return (e: FormEvent<HTMLInputElement>) => {
    const target = e.target as HTMLInputElement;
    const originalValue = target.dataset.value ?? '';
    let enteredValue = target.value ?? '';
    const enteredChar = enteredValue[enteredValue.length - 1];
    const isForward = enteredValue.length > originalValue.length;
    const char: string[] = [];

    // if first mask characters are strings, add them automatically
    const leadingChars = [];
    if (originalValue.length === 0) {
      while (typeof mask[leadingChars.length] === 'string') {
        leadingChars.push(mask[leadingChars.length]);
      }
    }

    // if user has deleted characters we need to re-add mask characters
    if (typeof mask[enteredValue.length - 1] === 'string' && isForward) {
      enteredValue = originalValue;
      while (typeof mask[enteredValue.length] === 'string') {
        enteredValue += mask[enteredValue.length];
      }
      enteredValue += enteredChar;
    }

    // Normalize the value against the mask
    [...leadingChars, ...enteredValue.split('')].forEach((v, i) => {
      if (typeof mask[i] === 'string') char.push(mask[i] as string);
      if (mask[i] instanceof RegExp) {
        if ((mask[i] as RegExp).test(v as string)) char.push(v as string);
      }
    });

    // automatically add the next mask characters if they are strings
    while (typeof mask[char.length] === 'string' && isForward) {
      char.push(mask[char.length] as string);
    }

    // join chars and slice at length of mask to prevent additional characters
    const finalValue = char.join('').slice(0, mask.length);

    // save/set value
    target.dataset.value = finalValue;
    target.value = finalValue;
  };
}

export const maskPhoneNumber = maskInput([/\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]);
export const maskDate = maskInput([/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]);
export const maskISODate = maskInput([/\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/]);
